// extracted by mini-css-extract-plugin
export default {"item":"Item_item__ItltS","active":"Item_active__gT5wo","head":"Item_head__4OEkU","body":"Item_body__RWUke","button":"Item_button__3CAMT"};